module.exports = __webpack_public_path__ + "static/img/jiaban.c0cbdb31.png";